import { Link } from "react-router-dom";
import { MapPin, Phone, Clock, Mail } from "lucide-react";
import { Logo } from "./Logo";
import { SHOWROOM } from "@/lib/showroom";

const Detail = ({ icon: Icon, children, testId }) => (
  <li className="flex items-start gap-3 text-sm text-[#A09E97]" data-testid={testId}>
    <Icon className="w-4 h-4 mt-0.5 shrink-0 text-[#D4AF37]" />
    <span>{children}</span>
  </li>
);

const link = "hover:text-[#E5C158] transition-colors";

export const Footer = () => (
  <footer className="no-print border-t border-[#D4AF37]/15 mt-32" data-testid="site-footer">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-10 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-[1.2fr_1fr_1fr_auto] lg:items-end">
      <div>
        <Logo />
        <p className="mt-6 text-sm text-[#A09E97] max-w-xs">The working catalogue of Sterling Joinery — projects, materials and fittings.</p>
      </div>

      <div data-testid="footer-showroom">
        <p className="font-mono-j text-xs uppercase tracking-[0.25em] text-[#D4AF37] mb-5">Showroom</p>
        <ul className="space-y-3">
          <Detail icon={MapPin} testId="footer-showroom-address">
            <a href={SHOWROOM.mapsHref} target="_blank" rel="noreferrer" className={link}>{SHOWROOM.address}</a>
          </Detail>
          <Detail icon={Phone} testId="footer-showroom-phone">
            <a href={SHOWROOM.phoneHref} className={link}>{SHOWROOM.phone}</a>
          </Detail>
          <Detail icon={Clock} testId="footer-showroom-hours">{SHOWROOM.hours}</Detail>
          <Detail icon={Mail} testId="footer-showroom-email">
            <a href={`mailto:${SHOWROOM.email}`} className={link}>{SHOWROOM.email}</a>
          </Detail>
        </ul>
      </div>

      <p className="font-display italic text-4xl text-[#F5F3EF]/90 lg:text-center">Made to measure.</p>

      <div className="flex lg:justify-end gap-6 font-mono-j text-xs uppercase tracking-[0.2em] text-[#A09E97]">
        <Link to="/print" data-testid="footer-print-link" className={link}>Print A4</Link>
        <Link to="/admin" data-testid="footer-admin-link" className={link}>Admin</Link>
        <span>© {new Date().getFullYear()}</span>
      </div>
    </div>
  </footer>
);
